import axios, { AxiosError } from "axios";
import { useContext } from "react";
import useSWR from "swr";
import { AuthContext } from "../../../context/AuthContext";
import { TRADES_API_URL } from "../../../utils/env";
import { FilledTradesEndpointEnum } from "../../../enums/endpoints";

export interface IBuybackAndBurnRecord {
  month: string;
  totalVolume: number;
  tier: string;
  burnAmount: number;
  buybackAmount: number;
  createdTimestamp: number;
}

interface IBuybacksAndBurnsResponse {
  success: boolean;
  message: string;
  data: IBuybackAndBurnRecord[];
}

export const useBuybacksAndBurns = () => {
  const { tokenId } = useContext(AuthContext);

  const fetchBuybacksAndBurns = async (): Promise<
    IBuybackAndBurnRecord[] | undefined
  > => {
    if (!tokenId) {
      return undefined;
    }

    try {
      const response = await axios.get<IBuybacksAndBurnsResponse>(
        TRADES_API_URL(FilledTradesEndpointEnum.BUYBACKS_AND_BURNS),
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${tokenId}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      if (response.data.success && response.data.data) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      // do nothing
      return undefined;
    }
  };

  const swr = useSWR<IBuybackAndBurnRecord[] | undefined, AxiosError>(
    tokenId ? ["buybacks-and-burns", tokenId] : null,
    fetchBuybacksAndBurns,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 60000,
      refreshInterval: 300000,
    }
  );

  return {
    ...swr,
  };
};
